import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-top: ${({ withInfo }) => (withInfo ? "0px" : "48px")};
`;

export const Icon = styled.img`
  width: ${({ withInfo }) => (withInfo ? "183px" : "110px")};
  height: ${({ withInfo }) => (withInfo ? "183px" : "110px")};
  margin-bottom: ${({ withInfo }) => (withInfo ? "36px" : "24px")};

  @media (max-width: 360px) {
    width: 127px;
    height: 127px;
  }
`;

export const Text = styled.p`
  font-weight: 400;
  margin: 0;
  font-size: ${({ withInfo }) => (withInfo ? "28px" : "16px")};
  color: rgba(255, 255, 255, 1);
  line-height: 120%;
  font-family: "ST-SimpleSquare", sans-serif;

  @media (max-width: 360px) {
    font-size: 20px;
  }
`;

export const TextInfo = styled.p`
  font-weight: 400;
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 150%;
  max-width: 319px;
  margin-top: 16px;
`;
